import { useMemo } from 'react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { useFm } from '@web3/base-hooks';
import { ProjectTime } from '@/types/home';

dayjs.extend(isBetween);

export const useStepList = (timeList: ProjectTime[]) => {
  const fm = useFm();
  const formatTime = (timestamp) => {
    return dayjs(timestamp).utc().format('YYYY-MM-DD HH:mm');
  };
  const stepList = useMemo(
    () => [
      {
        label: fm('wave1'),
        timeStart: formatTime(timeList?.[0]?.start) || '2025.2.28 00:00',
        timeEnd: formatTime(timeList?.[0]?.end) || '2025.3.13 23:59',
        showTimeStart: '2025.2.28 00:00',
        showTimeEnd: '2025.3.13 23:59',
      },
      {
        label: fm('wave2'),
        timeStart: formatTime(timeList?.[1]?.start) || '2025.3.14 00:00',
        timeEnd: formatTime(timeList?.[1]?.end) || '2025.3.27 23:59',
        showTimeStart: '2025.3.14 00:00',
        showTimeEnd: '2025.3.27 23:59',
      },
    ],
    [fm, timeList]
  );

  const currentStep = useMemo(() => {
    let currentStepTmp = 0;
    // 早于开始
    if (dayjs().isBefore(dayjs(stepList[0].timeStart).utc(true))) {
      return 0;
    }
    // 晚于最后
    if (
      dayjs().isAfter(dayjs(stepList[stepList.length - 1].timeEnd).utc(true))
    ) {
      return stepList.length - 1;
    }
    // 中间阶段
    for (let i = 0; i < stepList.length; i++) {
      const item = stepList[i];
      const timeToUtc = (time) => {
        return dayjs(time).utc(true);
      };
      if (
        dayjs().isBetween(timeToUtc(item.timeStart), timeToUtc(item.timeEnd))
      ) {
        currentStepTmp = i;
        break;
      }
    }
    return currentStepTmp;
  }, [stepList]);

  return { stepList, currentStep };
};
